import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const pathStart = 'Candidate|Program History|Badging|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ShareCertMetricsBadging,
	portal: 'SP',
};
const columnHeadingStart = 'Column heading for: ';

type LocNameStart = 'SPCandidateBadging';
export type SPCandidateBadgingLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}TitlePageDescription`
	| `${LocNameStart}ContentPageDescription`
	| `${LocNameStart}TitlePageSection`
	| `${LocNameStart}ButtonPreview`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelDescription`
	| `${LocNameStart}ContentDescription`
	| `${LocNameStart}LabelActiveDate`
	| `${LocNameStart}LabelExpireDate`
	| `${LocNameStart}LabelType`
	| `${LocNameStart}LabelPreview`
	| `${LocNameStart}LabelImage`;

export const spCandidateBadgingLocs: LocDefs<SPCandidateBadgingLocNames> = {
	SPCandidateBadgingTitlePage: {
		defaultValue: 'Candidate Badging',
		description: 'Page Title',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'Share.CertMetricsBadging/CandidateProfile.ProgramHistory.Badging.PageTitle',
		...sharedProperties,
	},
	SPCandidateBadgingTitlePageDescription: {
		defaultValue: 'Instructions',
		description: 'Page Description Title',
		displayPath: `${pathStart}Page Description Title`,
		displayType: 'Title',
		legacyName:
			'Share.CertMetricsBadging/CandidateProfile.ProgramHistory.Badging.PageDescriptionTitle',
		...sharedProperties,
	},
	SPCandidateBadgingContentPageDescription: {
		defaultValue: '',
		description: 'Page Description',
		displayPath: `${pathStart}Page Description`,
		displayType: 'Content',
		legacyName:
			'Share.CertMetricsBadging/CandidateProfile.ProgramHistory.Badging.PageDescription',
		...sharedProperties,
		htmlAllowed: true,
	},
	SPCandidateBadgingTitlePageSection: {
		defaultValue: 'Badging',
		description: 'Section title.',
		displayPath: `${pathStart}Section title`,
		displayType: 'Title',
		legacyName:
			'Share.CertMetricsBadging/CandidateProfile.ProgramHistory.Badging.PageSectionTitle',
		...sharedProperties,
	},
	SPCandidateBadgingButtonPreview: {
		defaultValue: 'Preview',
		description: 'Preview link.',
		displayPath: `${pathStart}Preview`,
		displayType: 'Button',
		legacyName: 'Share.CertMetricsBadging/CandidateProfile.ProgramHistory.Badging.PreviewLink',
		...sharedProperties,
	},
	SPCandidateBadgingLabelName: {
		defaultValue: 'Name',
		description: `${columnHeadingStart}Name.`,
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName: 'Share.CertMetricsBadging/CandidateProfile.ProgramHistory.Badging.Column.Name',
		...sharedProperties,
	},
	SPCandidateBadgingLabelDescription: {
		defaultValue: 'Description',
		description: `${columnHeadingStart}Description.`,
		displayPath: `${pathStart}Description`,
		displayType: 'Label',
		legacyName:
			'Share.CertMetricsBadging/CandidateProfile.ProgramHistory.Badging.Column.Description',
		...sharedProperties,
	},
	SPCandidateBadgingContentDescription: {
		defaultValue: 'HTML',
		description: `Text shown when there row has a description.`,
		displayPath: `${pathStart}Item Description`,
		displayType: 'Content',
		legacyName:
			'Share.CertMetricsBadging/CandidateProfile.ProgramHistory.Badging.Content.DescriptionDisplay',
		...sharedProperties,
	},
	SPCandidateBadgingLabelActiveDate: {
		defaultValue: 'Active Date',
		description: `${columnHeadingStart}Active Date`,
		displayPath: `${pathStart}Active Date`,
		displayType: 'Label',
		legacyName:
			'Share.CertMetricsBadging/CandidateProfile.ProgramHistory.Badging.Column.ActiveDate',
		...sharedProperties,
	},
	SPCandidateBadgingLabelExpireDate: {
		defaultValue: 'Expire Date',
		description: `${columnHeadingStart}Expire Date`,
		displayPath: `${pathStart}Expire Date`,
		displayType: 'Label',
		legacyName:
			'Share.CertMetricsBadging/CandidateProfile.ProgramHistory.Badging.Column.ExpireDate',
		...sharedProperties,
	},
	SPCandidateBadgingLabelType: {
		defaultValue: 'Type',
		description: `${columnHeadingStart}Type`,
		displayPath: `${pathStart}Type`,
		displayType: 'Label',
		legacyName: 'Share.CertMetricsBadging/CandidateProfile.ProgramHistory.Badging.Column.Type',
		...sharedProperties,
	},
	SPCandidateBadgingLabelPreview: {
		defaultValue: 'Preview',
		description: `${columnHeadingStart}Preview`,
		displayPath: `${pathStart}Preview`,
		displayType: 'Label',
		legacyName:
			'Share.CertMetricsBadging/CandidateProfile.ProgramHistory.Badging.Column.Preview',
		...sharedProperties,
	},
	SPCandidateBadgingLabelImage: {
		defaultValue: 'Badge Image',
		description: `${columnHeadingStart}Badge Image`,
		displayPath: `${pathStart}Badge Image`,
		displayType: 'Label',
		legacyName:
			'Share.CertMetricsBadging/CandidateProfile.ProgramHistory.Badging.Column.BadgeImage',
		...sharedProperties,
	},
};

export type SPCandidateBadgingLocType = LocMap<SPCandidateBadgingLocNames>;
